import { motion } from "framer-motion";
import { CheckCircle2, ClipboardCheck, PhoneCall, Search } from "lucide-react";
import { LegalLinks } from "@/components/LegalLinks";

const NEXT = [
  { icon: Search, text: "We review your photos and project details." },
  { icon: PhoneCall, text: "We call or text you to ask a few questions." },
  { icon: ClipboardCheck, text: "If it's a fit, we schedule a visit and send your quote." },
];

export const ThankYou = ({ companyName, summary, preview }) => (
  <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="py-8" data-testid="thank-you-container">
    <motion.span initial={{ scale: 0.6 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 260, damping: 16, delay: 0.1 }}
      className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 ring-8 ring-emerald-50/60">
      <CheckCircle2 className="h-8 w-8" />
    </motion.span>
    <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="thank-you-title">Thanks!</h1>
    <p className="mt-2 text-lg leading-relaxed text-slate-600" data-testid="thank-you-message">{companyName} will review your project and get back to you soon.</p>
    {preview}
    {summary && (
      <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-soft" data-testid="thank-you-summary">
        <p className="text-sm font-semibold text-slate-900">What you sent</p>
        <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
          {summary.map(([k, v]) => (
            <div key={k}><dt className="text-slate-500">{k}</dt><dd className="font-medium text-slate-900">{v}</dd></div>
          ))}
        </dl>
      </div>
    )}
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-soft" data-testid="thank-you-next-steps">
      <p className="text-sm font-semibold text-slate-900">What happens next</p>
      <ol className="mt-3 space-y-3">
        {NEXT.map(({ icon: Icon, text }, i) => (
          <li key={i} className="flex items-start gap-3 text-sm text-slate-700">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg brand-tint text-[color:var(--brand)]"><Icon className="h-4 w-4" /></span>
            <span className="pt-1.5">{text}</span>
          </li>
        ))}
      </ol>
    </div>
    <LegalLinks className="mt-8" />
  </motion.div>
);

export const Unavailable = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6" data-testid="public-page-unavailable">
    <div className="max-w-sm text-left">
      <h1 className="text-3xl font-bold tracking-tight text-slate-900">This page is temporarily unavailable</h1>
      <p className="mt-3 text-slate-600">Please check back later or contact the company directly.</p>
    </div>
  </div>
);
